import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { Row, Col, Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { HomeCard } from "./../HomeCard";
import { FichaFinanceiraService, FichaFechamentoService } from "./../../../services";
import { HomeContext } from "../../../contexts";
import { PlanoVinculadoEntidade } from "../../../entidades";
import { LoadingComponent } from "../../../components";

export const Ativo: React.FC = () => {
  const context = useContext(HomeContext);

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [UltimaContribuicao, setUltimaContribuicao] = useState<any>({});
  const [Saldos, setSaldos] = useState<any>({});

  const [Loading, setLoading] = useState<boolean>(false);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const Plano = await context.buscarPlano();

        const ultimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano(Plano.CD_PLANO);
        const saldos = await FichaFechamentoService.BuscarSaldoPorPlano(Plano.CD_PLANO);

        setUltimaContribuicao(ultimaContribuicao);
        setSaldos(saldos);
        setPlano(Plano);
      }
      catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [context]);

  return (
    <div>
      {Loading && <LoadingComponent />}

      {!Loading && Erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && Erro === "" && UltimaContribuicao &&
        <div>
          <Row>
            <Col>
              <HomeCard titulo={Plano.DS_PLANO}>
                {Plano.DS_CATEGORIA}
              </HomeCard>
            </Col>
            {typeof UltimaContribuicao !== "string" &&
              <Col>
                <HomeCard titulo={"Contribuição Atual"} >
                  {UltimaContribuicao.Percentual}%
                </HomeCard>
              </Col>
            }
            {typeof UltimaContribuicao !== "string" &&
              <Col>
                <HomeCard titulo={"Salário de Participação"}>
                  <CampoEstatico valor={UltimaContribuicao.SRC} tipo={TipoCampoEstatico.dinheiro} />
                </HomeCard>
              </Col>
            }
            <Col>
              <HomeCard titulo={"Data de Inscrição"}>
                {Plano.DT_INSC_PLANO}
              </HomeCard>
            </Col>
            <Col>
              <HomeCard titulo={"Regime de Tributação"}>
                {Plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
              </HomeCard>
            </Col>
          </Row>

          {typeof UltimaContribuicao !== "string" &&
            <Row className={"mt-4"}>
              <Col>
                <Box renderRow={true} titulo={"Sua Última Contribuição"} label={`Posição de ${moment(UltimaContribuicao.DataReferencia, "DD/MM/YYYY").format("DD/MM/YYYY")}`}>

                  <table className={"table table-striped table-sm"}>
                    <tbody>
                      {UltimaContribuicao.Contribuicoes && UltimaContribuicao.Contribuicoes.map((contrib: any, index: number) => {
                        // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
                        var Td = (props: any) => <td className={props.className}>{props.children}</td>;

                        if (index == UltimaContribuicao.Contribuicoes.length - 1)
                          Td = (props: any) => <th className={props.className}>{props.children}</th>;

                        return (
                          <tr key={index}>
                            <Td>{contrib.Item1}</Td>
                            <Td className={"text-right"}>
                              <CampoEstatico valor={contrib.Item2} tipo={TipoCampoEstatico.dinheiro} />
                            </Td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>

                </Box>

                <Box renderRow={true} titulo={"Custeio"} label={`Posição de ${moment(UltimaContribuicao.DataReferencia, "DD/MM/YYYY").format("DD/MM/YYYY")}`}>

                  <table className={"table table-striped table-sm"}>
                    <tbody>
                      {UltimaContribuicao.Descontos && UltimaContribuicao.Descontos.map((desconto: any, index: number) => {
                        // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
                        var Td = (props: any) => <td className={props.className}>{props.children}</td>;

                        if (index == UltimaContribuicao.Descontos.length - 1)
                          Td = (props: any) => <th className={props.className}>{props.children}</th>;

                        return (
                          <tr key={index}>
                            <Td>{desconto.DS_AGRUPADOR_WEB}</Td>
                            <Td className={"text-right"}>
                              <CampoEstatico valor={desconto.CONTRIB_PARTICIPANTE} tipo={TipoCampoEstatico.dinheiro} />
                            </Td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>

                  <b>Valor Líquido (Contribuição Total - Custeio Total): <CampoEstatico valor={UltimaContribuicao.Liquido} tipo={TipoCampoEstatico.dinheiro} /></b>

                </Box>
              </Col>

              <Col>
                <Box titulo={"Seu Saldo"} label={`Posição de ${Saldos.DT_FECHAMENTO !== undefined ? Saldos.DT_FECHAMENTO.substring(3) : ""}`}>

                  <table className={"table table-borderless table-sm"}>
                    <tbody>
                      <tr>
                        <td>Minhas Contribuições (total):</td>
                        <td className={'text-right'}>
                          <CampoEstatico valor={Saldos.VL_GRUPO1} tipo={TipoCampoEstatico.dinheiro} />
                        </td>
                      </tr>
                      <tr>
                        <td>Contribuições Patronais (total):</td>
                        <td className={'text-right'}>
                          <CampoEstatico valor={Saldos.VL_GRUPO2} tipo={TipoCampoEstatico.dinheiro} />
                        </td>
                      </tr>
                      <tr>
                        <td>Contribuições Totais:</td>
                        <td className={'text-right'}>
                          <CampoEstatico valor={Saldos.VL_GRUPO1 + Saldos.VL_GRUPO2} tipo={TipoCampoEstatico.dinheiro} />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <hr />

                  <div className={"mb-3 pl-2 pr-2 table"}>
                    Rendimento do Plano:
                    <p className={"float-right"}>
                      <CampoEstatico valor={Saldos.VL_ACUMULADO - (Saldos.VL_GRUPO1 + Saldos.VL_GRUPO2)} tipo={TipoCampoEstatico.dinheiro} />
                    </p>
                  </div>

                  <div className={"alert alert-success"}>
                    <b>Saldo Acumulado Atualizado:</b>
                    <p className={"float-right"}>
                      <b><CampoEstatico valor={Saldos.VL_ACUMULADO} tipo={TipoCampoEstatico.dinheiro} /></b>
                    </p>
                  </div>

                  <p className={"text-info"}>
                    Valor da cota em {Saldos.DT_FECHAMENTO !== undefined ? Saldos.DT_FECHAMENTO.substring(3) : ""}: <CampoEstatico valor={Saldos.VL_COTA} tipo={TipoCampoEstatico.texto} />
                  </p>
                </Box>
              </Col>
            </Row>
          }

          {UltimaContribuicao.msgAdicional &&
            <Alerta tipo={TipoAlerta.danger} mensagem={UltimaContribuicao.msgAdicional} />
          }
        </div>
      }
    </div>
  );
}